// @flow
import type {ClientsForPlatform, Platform} from 'docs/data/integration-builder';

export const getPlatform = (
  clients: ClientsForPlatform,
  client: string,
): ?Platform => {
  let platform = null;
  Object.keys(clients).reduce((found, p) => {
    const platformSupportsClient = clients[p].includes(client);
    if (platformSupportsClient) {
      platform = p;
    }
    return found || platformSupportsClient;
  }, false);

  return platform;
};
